import React from 'react';
import {
  FaTools,
  FaDraftingCompass,
  FaWarehouse,
  FaProjectDiagram,
  FaLightbulb,
} from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import './Rotate.css';
import img1 from '../../assets/images/construction-worker-7859047_1920.jpg';

const expertise = [
  { icon: <FaTools size={30} />, label: 'Fabrication' },
  { icon: <FaDraftingCompass size={30} />, label: 'Design' },
  { icon: <FaWarehouse size={30} />, label: 'Bulk Storage' },
  { icon: <FaProjectDiagram size={30} />, label: 'EPC Projects' },
  { icon: <FaLightbulb size={30} />, label: 'Innovation' },
];

const Rotate = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full min-h-[700px] bg-gray-100 px-4 py-16 flex flex-col-reverse md:flex-row items-center justify-center gap-16 md:gap-28 overflow-hidden">

      {/* Animated Slogan Card with Button */}
      <motion.div
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        viewport={{ once: true }}
        className="w-full max-w-md bg-white rounded-2xl shadow-xl p-6 text-center flex flex-col items-center"
      >
        <img
          src={img1}
          alt="Industrial"
          className="w-full h-56 object-cover rounded-xl mb-4"
          loading="lazy"
        />
        <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">
          Engineering Excellence
        </h2>
        <p className="text-sm sm:text-base text-gray-600 mb-4">
          At LABH Industries, we combine innovation with precision to deliver reliable solutions that power industrial progress.
        </p>
        <button
          onClick={() => navigate('/service')}
          className="bg-[#5bc0fe] hover:bg-yellow-600 text-white font-semibold py-2 px-6 rounded-full transition duration-300 shadow-md"
        >
          Explore Services
        </button>
      </motion.div>

      {/* Rotating Circle */}
      <div className="relative w-[280px] h-[280px] sm:w-[400px] sm:h-[400px] md:w-[500px] md:h-[500px]">
        {/* Center text */}
        <div className="absolute top-1/2 left-1/2 w-[100px] sm:w-[120px] md:w-[140px] h-[100px] sm:h-[120px] md:h-[140px] bg-[#e6b127] text-white rounded-full flex items-center justify-center text-center font-bold text-sm sm:text-base md:text-lg transform -translate-x-1/2 -translate-y-1/2 shadow-xl z-10">
          LABH<br />Industries
        </div>

        {/* Rotating items */}
        <div className="absolute inset-0 origin-center animate-rotate-circle">
          {expertise.map((item, index) => {
            const total = expertise.length;
            const angle = (360 / total) * index;
            const radius = 130; // Adjusted for responsiveness
            const rad = (angle * Math.PI) / 180;
            const x = radius * Math.cos(rad);
            const y = radius * Math.sin(rad);

            return (
              <div
                key={index}
                className="absolute flex flex-col items-center justify-center w-20 sm:w-24"
                style={{
                  top: `calc(50% + ${y}px)`,
                  left: `calc(50% + ${x}px)`,
                  transform: 'translate(-50%, -50%) rotate(-0deg)',
                }}
              >
                <div className="flex flex-col items-center text-[#e6b127] rotate-unwind text-center">
                  {item.icon}
                  <p className="text-xs sm:text-sm text-gray-800 font-medium mt-1">
                    {item.label}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Rotate;
